import React from 'react';
import './App.css';
import { BrowserRouter, Routes, Route, useLocation } from 'react-router-dom';
import Login from './pages/Login';
import Home from './pages/Home';
import NewServiceCall from './pages/NewServiceCall';
import ServiceCallsList from './pages/ServiceCallsList';
import ServiceCallsReport from './pages/ServiceCallsReport';
import DailyLog from './pages/DailyLog';
import DailyLogsList from './pages/DailyLogsList';
import DealClosure from './pages/DealClosure';
import DealClosuresList from './pages/DealClosuresList';
import ManagerLogin from './pages/ManagerLogin';
import Manager from './pages/Manager';
import CustomerReport from './pages/CustomerReport';
import Reports from './pages/Reports';
import DebtorsReport from './pages/DebtorsReport';
import ProjectExecutionSteps from './pages/ProjectExecutionSteps';
import PurchaseInvoices from './pages/PurchaseInvoices';
import DailyJournal from './pages/DailyJournal';
import CustomersList from './pages/CustomersList';
import BusinessCustomer from './pages/BusinessCustomer';
import PrivateCustomer from './pages/PrivateCustomer';
import Work from './pages/Work';
import WorkForm from './pages/WorkForm';
import WorkDetails from './pages/WorkDetails';
import PriceList from './pages/PriceList';
import WorkDetailList from './pages/WorkDetailList';
import PrintWorkReport from './pages/PrintWorkReport';
import PrintCustomerReport from './pages/PrintCustomerReport';
import MonthlyReport from './pages/MonthlyReport';
import WorkPayments from './pages/WorkPayments';
import ProductKey from './pages/ProductKey';
import Customers from './pages/Customers';
import CustomerCard from './pages/CustomerCard';
import VatReport from './pages/VatReport';
import DailyIncomeReport from './pages/DailyIncomeReport';
import PolicyPage from './pages/PolicyPage';
import ChecksReport from './pages/ChecksReport';
import ProfitByCustomer from './pages/ProfitByCustomer';
import ConsolidatedInvoice from './pages/ConsolidatedInvoice';
import ConsolidatedInvoicesList from './pages/ConsolidatedInvoicesList';
import SupportTickets from './pages/SupportTickets';
import ProtectedRoute from './components/ProtectedRoute';
import AuthCallback from './components/AuthCallback';
import FloatingHomeButton from './components/FloatingHomeButton';
import { Toaster } from './components/ui/toaster';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  // Check URL fragment synchronously for session_id (prevents race conditions)
  if (location.hash?.includes('session_id=')) {
    return <AuthCallback />;
  }
  return (
    <>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route path="/privacy" element={<PolicyPage type="privacy" />} />
      <Route path="/terms" element={<PolicyPage type="terms" />} />
      <Route path="/home" element={<ProtectedRoute><Home /></ProtectedRoute>} />
      <Route path="/work" element={<ProtectedRoute><Work /></ProtectedRoute>} />
      <Route path="/work-form" element={<ProtectedRoute><WorkForm /></ProtectedRoute>} />
      <Route path="/work-details" element={<ProtectedRoute><WorkDetails /></ProtectedRoute>} />
      <Route path="/work-payments" element={<ProtectedRoute><WorkPayments /></ProtectedRoute>} />
      <Route path="/price-list" element={<ProtectedRoute><PriceList /></ProtectedRoute>} />
      <Route path="/work-detail-list" element={<ProtectedRoute><WorkDetailList /></ProtectedRoute>} />
      <Route path="/reports" element={<ProtectedRoute><Reports /></ProtectedRoute>} />
      <Route path="/print-work-report" element={<ProtectedRoute><PrintWorkReport /></ProtectedRoute>} />
      <Route path="/print-customer-report" element={<ProtectedRoute><PrintCustomerReport /></ProtectedRoute>} />
      <Route path="/debtors-report" element={<ProtectedRoute><DebtorsReport /></ProtectedRoute>} />
      <Route path="/monthly-report" element={<ProtectedRoute><MonthlyReport /></ProtectedRoute>} />
      <Route path="/project-execution-steps/:projectId" element={<ProtectedRoute><ProjectExecutionSteps /></ProtectedRoute>} />
      <Route path="/new-service-call" element={<ProtectedRoute><NewServiceCall /></ProtectedRoute>} />
      <Route path="/service-calls" element={<ProtectedRoute><ServiceCallsList /></ProtectedRoute>} />
      <Route path="/service-calls-report" element={<ProtectedRoute><ServiceCallsReport /></ProtectedRoute>} />
      <Route path="/daily-log" element={<ProtectedRoute><DailyLog /></ProtectedRoute>} />
      <Route path="/daily-logs" element={<ProtectedRoute><DailyLogsList /></ProtectedRoute>} />
      <Route path="/deal-closure" element={<ProtectedRoute><DealClosure /></ProtectedRoute>} />
      <Route path="/deal-closures" element={<ProtectedRoute><DealClosuresList /></ProtectedRoute>} />
      <Route path="/manager-login" element={<ProtectedRoute><ManagerLogin /></ProtectedRoute>} />
      <Route path="/manager" element={<ProtectedRoute><Manager /></ProtectedRoute>} />
      <Route path="/customer-report" element={<ProtectedRoute><CustomerReport /></ProtectedRoute>} />
      <Route path="/purchase-invoices" element={<ProtectedRoute><PurchaseInvoices /></ProtectedRoute>} />
      <Route path="/daily-journal" element={<ProtectedRoute><DailyJournal /></ProtectedRoute>} />
      <Route path="/customers-list" element={<ProtectedRoute><CustomersList /></ProtectedRoute>} />
      <Route path="/business-customer" element={<ProtectedRoute><BusinessCustomer /></ProtectedRoute>} />
      <Route path="/private-customer" element={<ProtectedRoute><PrivateCustomer /></ProtectedRoute>} />
      <Route path="/product-key" element={<ProtectedRoute><ProductKey /></ProtectedRoute>} />
      <Route path="/customers" element={<ProtectedRoute><Customers /></ProtectedRoute>} />
      <Route path="/vat-report" element={<ProtectedRoute><VatReport /></ProtectedRoute>} />
      <Route path="/daily-income" element={<ProtectedRoute><DailyIncomeReport /></ProtectedRoute>} />
      <Route path="/customer-card/:id" element={<ProtectedRoute><CustomerCard /></ProtectedRoute>} />
      <Route path="/checks-report" element={<ProtectedRoute><ChecksReport /></ProtectedRoute>} />
      <Route path="/profit-by-customer" element={<ProtectedRoute><ProfitByCustomer /></ProtectedRoute>} />
      <Route path="/consolidated-invoice" element={<ProtectedRoute><ConsolidatedInvoice /></ProtectedRoute>} />
      <Route path="/consolidated-invoices" element={<ProtectedRoute><ConsolidatedInvoicesList /></ProtectedRoute>} />
      <Route path="/support-tickets" element={<ProtectedRoute><SupportTickets /></ProtectedRoute>} />
    </Routes>
    <FloatingHomeButton />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AppRouter />
      </BrowserRouter>
      <Toaster />
    </div>
  );
}

export default App;
